<template>
    <span id="waiting-area-edit">
        <!-- Button trigger modal -->
        <button type="button" class="btn btn-action btn-success btn-sm mr-2 mb-2" data-toggle="modal"
            :data-target="getDataTarget()" @click="resetForm()"><i class="fas fa-edit"></i></button>
            
        <!-- Modal -->
        <div class="modal fade text-left" :id="getModalId()" tabindex="-1" aria-labelledby="waitingAreaEditLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="waitingAreaEditLabel">Edit Waiting Area</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="alert.status" :class="getAlertClass()" role="alert">
                            <i :class="getAlertIcon()"></i> {{ alert.message }}
                        </div>
                        <form :id="getFormId()" @submit.prevent>
                            <div class="form-group">
                                <label for="waitingAreaValue">Waiting Area </label><small
                                    class="ml-1 font-weight-bold text-danger">*Required</small>
                                <input type="text" class="form-control form-control-sm" id="waitingAreaValue"
                                    name="waitingAreaValue" v-model="waitingAreaValue" aria-describedby="waitingAreaValue"
                                    placeholder="Please provide a waiting area">
                            </div>
                            <div class="form-group">
                                <label for="notes">Notes </label>
                                <textarea type="text" class="form-control form-control-sm" id="notes" name="notes"
                                    v-model="notes" aria-describedby="notes" rows="3"
                                    placeholder="Please provide any additional notes/information (not required)"></textarea>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button v-if="loading" disabled type="button" class="btn btn-primary">Saving <i
                                class="fas fa-spinner fa-spin"></i></button>
                        <button v-else type="button" class="btn btn-primary" :disabled="validateForm()"
                            @click="editWaitingArea()">Save</button>
                        <button type="button" class="btn btn-warning" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </span>
</template>

<script>
export default {
    name: 'waiting-area-edit',
    props: {
        waitingArea: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            alert: {
                message: '',
                status: false,
                type: ''
            },
            loading: false,
            notes: '',
            waitingAreaValue: ''
        }
    },
    methods: {
        editWaitingArea() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?setWaitingAreasData`;
            const formData = new FormData();

            // Set loading
            this.alert.status = false;
            this.loading = true;

            // Add form keypair values
            formData.append('data', JSON.stringify({
                id: this.waitingArea.id,
                notes: this.notes,
                waitingArea: this.waitingAreaValue
            }));
            formData.append('mode', 'setWaitingAreasData');

            // POST request
            fetch(api, {
                method: 'POST',
                body: formData
            }).then(function (response) {
                return response.json();
            }).then(function (json) {
                // Update system settings
                if (json.result.match(/OK/i)) {
                    that.alert.message = `${that.waitingAreaValue} has been successfully saved.`;
                    that.alert.type = "success";
                } else if (json.result.match(/WARNING/i)) {
                    // Other error
                    that.alert.message = `${that.waitingAreaValue} could not be saved. ${json.message}`;
                    that.alert.type = "warning";
                } else {
                    // Internal error
                    that.alert.message = `${that.waitingAreaValue} could not be saved. An error has occurred. Please contact your system administrator.`;
                    that.alert.type = "danger";
                }

                that.refreshData();
                that.alert.status = true;
                that.loading = false;
            }).catch(function () {
                // Internal error
                that.alert.message = `${that.waitingAreaValue} could not be saved. An error has occurred. Please contact your system administrator.`;
                that.alert.type = "danger";
                that.alert.status = true;
                that.loading = false;
            })
        },
        getAlertClass() {
            if (this.alert.type == "success") {
                return `alert alert-success`;
            } else if (this.alert.type == "warning") {
                return `alert alert-warning`;
            } else if (this.alert.type == "danger") {
                return `alert alert-danger`;
            }

            return `alert alert-primary`;
        },
        getAlertIcon() {
            if (this.alert.type == "success") {
                return `fas fa-check`;
            } else if (this.alert.type == "warning") {
                return `fas fa-exclamation-circle`;
            } else if (this.alert.type == "danger") {
                return `fas fa-exclamation-triangle`;
            }

            return `fas fa-bell`;
        },
        getDataTarget() {
            return `#waitingAreaEdit-${this.waitingArea.id}`;
        },
        getFormId() {
            return `waitingAreaEditForm-${this.waitingArea.id}`;
        },
        getModalId() {
            return `waitingAreaEdit-${this.waitingArea.id}`;
        },
        refreshData() {
            this.$emit('refreshData');
        },
        resetForm() {
            this.alert = {
                message: '',
                status: false,
                type: ''
            };
            this.notes = this.waitingArea.notes || '';
            this.waitingAreaValue = this.waitingArea.waitingArea || '';
        },
        validateForm() {
            if (this.waitingAreaValue && this.waitingAreaValue.length >= 2) {
                return false;
            }

            return true;
        }
    }
}
</script>